export default {
  getBreadcrumbs: state => state.breadcrumbs
};
